import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import AuthProvider, { useAuth } from './auth/AuthProvider'
import Layout from './components/Layout';
import Demo from './views/demo'
import LoginView from './views/Login'

import './app.scss'

// @ts-ignore Possibly null baseUrl
const baseUrl: string = document.getElementsByTagName('base')[0].getAttribute('href')


const App = () => {
  return (
    <Router basename={baseUrl}>
      <Layout>
        <AuthProvider>
          <Routes>
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Demo />
                </RequireAuth>
              }
            />
            <Route path='/signin' element={<LoginView />} />
          </Routes>
        </AuthProvider>
      </Layout>
    </Router>
  )
}

function RequireAuth({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  if (!auth.user) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}

export default App